<template>
  <div>
    <div
      :class="'viewer-image ' + (compact ? 'viewer-compact-container' : '')"
      @mouseleave="hideNav"
      @mouseenter="showNav"
      ref="viewer-image"
      v-touch="{
        left: () => nextImg(),
        right: () => prevImg()
      }"
      :style="viewerContainerStyle"
    >
      <div
        :style="compactBullets"
        class="compact-bullets"
      >
        <i class="fas fa-circle" style="font-size: 0.6em;"></i>
        <i class="fas fa-circle" style="font-size: 0.8em;"></i>
        <i class="fas fa-circle"></i>
        <i class="fas fa-circle" style="font-size: 0.8em;"></i>
        <i class="fas fa-circle" style="font-size: 0.6em;"></i>
      </div>

      <div
        class="viewer-image-middle-container justify-center"
      >
        <span :class="'pika-counter ' + (
          !showingImageNavigation ? ' img-transparent' : ''
          )" >{{ selectedImageIndex + 1 }}/{{ images.length }}
        </span>

        <!-- preload images -->
        <img
          v-if="preloadImg1 && images && images[preloadImg1]"
          :src="fullPath + images[preloadImg1].image"
          style="width: 30px;position: absolute; left: 10000px"
        />
        <img
          v-if="preloadImg2 && images && images[preloadImg2]"
          :src="fullPath + images[preloadImg2].image"
          style="width: 30px;position: absolute; left: 10000px"
        />
        <!-- /preload images -->

        <v-img
          :src="fullPath + imageUrl1"
          :class="(
            image1Transparent ? ' img-transparent' : ''
          ) + ' img-preview-mobile'"
          @click="showFull"
        />
        <v-img
          :src="fullPath + imageUrl2"
          :class="(
            image2Transparent ? ' img-transparent' : ''
          ) + ' img-preview-mobile'"
          @click="showFull"
        />
      </div>
    </div>

  </div>
</template>

<script>
import methods from '../../methods/methods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectImagesPreviewMobile',

  data: () => {
    return {

    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    fullPath () {
      return this.s3url + this.imgFolder + '/'
    },

    compactBullets () {
      return {
        top: (this.imgHeight - 20) + 'px'
      }
    },

    imgHeight () {
      if (this.windowWidth) {
        // return ((this.windowWidth) / 4 * 3) // Old way
      }
      // Can't use this.windowWidth on Safari as when user zooms in with two finters,
      // this.windowWidth is wrong value. Value is pixels visible not actual width
      if (document.documentElement && document.documentElement.clientWidth && document.documentElement.clientWidth > 100) {
        return document.documentElement.clientWidth / 4 * 3
      }
      return this.windowWidth / 4 * 3
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    viewerContainerStyle () {
      let style = {}
      if (this.compact) {
        style.height = this.imgHeight + 'px'
      }
      return style
    },

  },

  methods: {
    ...methods
  }
}
</script>

<style>
.img-preview-mobile {
  height: 100% !important;
  width: auto !important;
}
</style>
